import React from "react";

const SegimageConsentForm = (
    {
        Paragraph,
        optos,
        optosHeader,
        Logo
    }
) => {
    return (
        <div className="mb-3 p-4">

            <div className="flex justify-center">
                <Logo
                    src={optosHeader}
                    className="w-52 md:w-56 lg:w-72 h-auto"
                />
            </div>

            <h1 className="text-2xl font-bold mb-2 justify-center items-center">Retinal Imaging Options</h1>
            <Paragraph>We are pleased to offer the Optos Optomap® ultra-wide field retinal imaging system to obtain an in-depth view of nearly the entire retina, often through an undilated pupil. This advanced imaging allows us to detect retinal abnormalities and ocular disease earlier and at a more treatable stage than previous methods.</Paragraph>
            <Paragraph>The retina is the only place in the body where blood vessels can be seen directly. Because of this, retinal imaging can help identify eye conditions such as glaucoma, macular degeneration, and retinal detachment, as well as potential signs of systemic health issues like diabetes, high blood pressure, and stroke.</Paragraph>
            <Paragraph>The Optomap®  imaging is quick, painless, and non-invasive. It involves looking into a special device that captures high-resolution images of the retina using low-energy laser light. The procedure typically takes just a few minutes and does not require any eye drops or dilation.</Paragraph>
            <div className="max-w-4xl mx-auto border border-gray-300 rounded-lg overflow-hidden">
                {/* Header */}
                <div className="grid grid-cols-2 bg-gray-100 font-semibold text-center text-black">
                    <div className="p-3 border-r border-gray-300">Optos Optomap®</div>
                    <div className="p-3">Dilated Eye Exam</div>
                </div>
                {/* Row 1 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">Instant 200 degree view of the retina.</div>
                    <div className="p-3">Limited to 45 degrees retina per view.</div>
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">No eye drops required</div>
                    <div className="p-3">Dilating eye drops required</div>
                </div>

                {/* Row 3 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">No side effects</div>
                    <div className="p-3">Side effects of blurry vision and light sensitivity</div>
                </div>

                {/* Row 4 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">Takes less than 1 minute for imaging</div>
                    <div className="p-3">Dilation drops take an additional 20-30 minutes</div>
                </div>

                {/* Row 5 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">Digital image for a detailed exam record</div>
                    <div className="p-3">Written exam record</div>
                </div>

                {/* Row 6 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">Compare images for changes over time</div>
                    <div className="p-3">Cannot detect subtle changes over time</div>
                </div>

                {/* Row 7 */}
                <div className="grid grid-cols-2 border-b border-gray-300">
                    <div className="p-3 border-r border-gray-300">Quicker diagnosis and monitoring of retinal disease</div>
                    <div className="p-3">Smaller viewing range may slow diagnosis and disease management</div>
                </div>

                {/* Row 8 */}
                <div className="grid grid-cols-2">
                    <div className="p-3 border-r border-gray-300">Multiple image types to view deeper layers of the retina</div>
                    <div className="p-3">Deeper layers of the retina cannot be visualized using traditional lenses and lights</div>
                </div>
            </div>

            <Paragraph>Yearly retinal evaluation is recommended for all patients. Choose Optomap for the most comprehensive eye health check. </Paragraph>
            <Paragraph>*Dilation drops may be recommended by your doctor under certain circumstances.* </Paragraph>
            <Paragraph>There is an additional fee of $39.00 for the Optos imaging. </Paragraph>
        </div>
    );
};

export default SegimageConsentForm;
